export default {
  feedback: {
    login_success: 'Connexion réussie',
    logout_success: 'Déconnexion réussie',
  },
};
